var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 8.33333H1.66675M9.16675 15.8333L15.6667 15.8333C16.6002 15.8333 17.0669 15.8333 17.4234 15.6517C17.737 15.4919 17.992 15.2369 18.1518 14.9233C18.3334 14.5668 18.3334 14.1001 18.3334 13.1667V6.83333C18.3334 5.89991 18.3334 5.4332 18.1518 5.07668C17.992 4.76308 17.737 4.50811 17.4234 4.34832C17.0669 4.16667 16.6002 4.16667 15.6667 4.16667H14.1667M9.16675 15.8333L10.8334 17.5M9.16675 15.8333L10.8334 14.1667M5.83341 15.8333H4.33341C3.39999 15.8333 2.93328 15.8333 2.57676 15.6517C2.26316 15.4919 2.00819 15.2369 1.8484 14.9233C1.66675 14.5668 1.66675 14.1001 1.66675 13.1667V6.83333C1.66675 5.89991 1.66675 5.4332 1.8484 5.07668C2.00819 4.76308 2.26316 4.50811 2.57676 4.34832C2.93328 4.16667 3.39999 4.16667 4.33342 4.16667H10.8334M10.8334 4.16667L9.16675 5.83333M10.8334 4.16667L9.16675 2.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactions-icon.71844bff0d99bcbed6634fab4be3f9f2.svg";
export { ForwardRef as ReactComponent };